import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { lineFontStyles } from 'src/constants';

const useStyles = makeStyles((theme: Theme) => ({
  cardTitle: {
    marginBottom: '5px',
    color: theme.palette.text.disabled,
  },

  input: {
    width: '100%',
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
  },

  cancelSaveButtons: {
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
  },

  cancelIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[100],
    '&:hover': {
      color: theme.palette.error.main,
    },
  },

  addedContentItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: lineFontStyles.fontSize,
    lineHeight: lineFontStyles.lineHeight,
  },
  fieldContainer: {
    height: '500px',
    overflowY: 'scroll',
    backgroundColor: theme.palette.grey[500],
    borderRadius: '5px',
    padding: '0px 15px 10px 15px',
  },
  fieldSearchBox: {
    position: 'sticky',
    top: 0,
    paddingTop: '10px',
    backgroundColor: theme.palette.grey[500],
  },
  fieldListContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '500px',
  },
  searchInput: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: '5px',
    width: '100%',
    marginBottom: '10px',
    padding: '5px 7px',
  },

  fieldListItem: {
    cursor: 'pointer',
    fontSize: lineFontStyles.fontSize,
    lineHeight: lineFontStyles.lineHeight,
  },
}));

export default useStyles;
